// Official F1 2026 Circuit Layouts
// All images sourced from official F1 media with consistent styling
// Historic/non-F1 circuits use local SVG files styled for this app

const F1_CIRCUIT_MAPS = 'https://media.formula1.com/image/upload/f_auto,c_limit,w_1320/content/dam/fom-website/2018-redesign-assets/Circuit%20Maps%2016x9/';

// Local circuit SVGs for historic/non-calendar tracks
// These are custom SVGs styled with gold (#FDB913) to match the app theme
const LOCAL_CIRCUITS = '/circuits/';

const circuitLayouts = {
  // 2026 F1 Calendar circuits (official F1 media - Circuit Maps)
  'bahrain': `${F1_CIRCUIT_MAPS}Bahrain_Circuit.png`,
  'saudi_arabia': `${F1_CIRCUIT_MAPS}Saudi_Arabia_Circuit.png`,
  'jeddah': `${F1_CIRCUIT_MAPS}Saudi_Arabia_Circuit.png`,
  'australia': `${F1_CIRCUIT_MAPS}Australia_Circuit.png`,
  'albert_park': `${F1_CIRCUIT_MAPS}Australia_Circuit.png`,
  'japan': `${F1_CIRCUIT_MAPS}Japan_Circuit.png`,
  'suzuka': `${F1_CIRCUIT_MAPS}Japan_Circuit.png`,
  'china': `${F1_CIRCUIT_MAPS}China_Circuit.png`,
  'shanghai': `${F1_CIRCUIT_MAPS}China_Circuit.png`,
  'miami': `${F1_CIRCUIT_MAPS}Miami_Circuit.png`,
  'imola': `${F1_CIRCUIT_MAPS}Emilia_Romagna_Circuit.png`,
  'emilia_romagna': `${F1_CIRCUIT_MAPS}Emilia_Romagna_Circuit.png`,
  'monaco': `${F1_CIRCUIT_MAPS}Monaco_Circuit.png`,
  'spain': `${F1_CIRCUIT_MAPS}Spain_Circuit.png`,
  'barcelona': `${F1_CIRCUIT_MAPS}Spain_Circuit.png`,
  'canada': `${F1_CIRCUIT_MAPS}Canada_Circuit.png`,
  'montreal': `${F1_CIRCUIT_MAPS}Canada_Circuit.png`,
  'austria': `${F1_CIRCUIT_MAPS}Austria_Circuit.png`,
  'red_bull_ring': `${F1_CIRCUIT_MAPS}Austria_Circuit.png`,
  'great_britain': `${F1_CIRCUIT_MAPS}Great_Britain_Circuit.png`,
  'silverstone': `${F1_CIRCUIT_MAPS}Great_Britain_Circuit.png`,
  'uk': `${F1_CIRCUIT_MAPS}Great_Britain_Circuit.png`,
  'united_kingdom': `${F1_CIRCUIT_MAPS}Great_Britain_Circuit.png`,
  'hungary': `${F1_CIRCUIT_MAPS}Hungary_Circuit.png`,
  'hungaroring': `${F1_CIRCUIT_MAPS}Hungary_Circuit.png`,
  'belgium': `${F1_CIRCUIT_MAPS}Belgium_Circuit.png`,
  'spa': `${F1_CIRCUIT_MAPS}Belgium_Circuit.png`,
  'netherlands': `${F1_CIRCUIT_MAPS}Netherlands_Circuit.png`,
  'zandvoort': `${F1_CIRCUIT_MAPS}Netherlands_Circuit.png`,
  'italy': `${F1_CIRCUIT_MAPS}Italy_Circuit.png`,
  'monza': `${F1_CIRCUIT_MAPS}Italy_Circuit.png`,
  'azerbaijan': `${F1_CIRCUIT_MAPS}Azerbaijan_Circuit.png`,
  'baku': `${F1_CIRCUIT_MAPS}Azerbaijan_Circuit.png`,
  'singapore': `${F1_CIRCUIT_MAPS}Singapore_Circuit.png`,
  'marina_bay': `${F1_CIRCUIT_MAPS}Singapore_Circuit.png`,
  'united_states': `${F1_CIRCUIT_MAPS}USA_Circuit.png`,
  'usa': `${F1_CIRCUIT_MAPS}USA_Circuit.png`,
  'austin': `${F1_CIRCUIT_MAPS}USA_Circuit.png`,
  'cota': `${F1_CIRCUIT_MAPS}USA_Circuit.png`,
  'mexico': `${F1_CIRCUIT_MAPS}Mexico_Circuit.png`,
  'mexico_city': `${F1_CIRCUIT_MAPS}Mexico_Circuit.png`,
  'brazil': `${F1_CIRCUIT_MAPS}Brazil_Circuit.png`,
  'sao_paulo': `${F1_CIRCUIT_MAPS}Brazil_Circuit.png`,
  'interlagos': `${F1_CIRCUIT_MAPS}Brazil_Circuit.png`,
  'las_vegas': `${F1_CIRCUIT_MAPS}Las_Vegas_Circuit.png`,
  'qatar': `${F1_CIRCUIT_MAPS}Qatar_Circuit.png`,
  'lusail': `${F1_CIRCUIT_MAPS}Qatar_Circuit.png`,
  'abu_dhabi': `${F1_CIRCUIT_MAPS}Abu_Dhabi_Circuit.png`,
  'yas_marina': `${F1_CIRCUIT_MAPS}Abu_Dhabi_Circuit.png`,
  'uae': `${F1_CIRCUIT_MAPS}Abu_Dhabi_Circuit.png`,
  
  // Historic/Additional circuits (Monochrome PNG images for CSS filter compatibility)
  // Argentina - Buenos Aires (Autódromo Juan y Oscar Gálvez - Circuit No. 6)
  'argentina': `${LOCAL_CIRCUITS}buenos-aires_mono.png`,
  'buenos_aires': `${LOCAL_CIRCUITS}buenos-aires_mono.png`,
  'autodromo_juan': `${LOCAL_CIRCUITS}buenos-aires_mono.png`,
  'argentinie': `${LOCAL_CIRCUITS}buenos-aires_mono.png`,
  
  // Portugal - Portimão (Autódromo Internacional do Algarve - 2021 layout)
  'portugal': `${LOCAL_CIRCUITS}portimao_mono.png`,
  'portimao': `${LOCAL_CIRCUITS}portimao_mono.png`,
  'algarve': `${LOCAL_CIRCUITS}portimao_mono.png`,
  
  // Malaysia - Sepang International Circuit (Grand Prix Circuit)
  'malaysia': `${LOCAL_CIRCUITS}sepang_mono.png`,
  'sepang': `${LOCAL_CIRCUITS}sepang_mono.png`,
  'kuala_lumpur': `${LOCAL_CIRCUITS}sepang_mono.png`,
  'maleisie': `${LOCAL_CIRCUITS}sepang_mono.png`,
  
  // Turkey - Istanbul Park (Grand Prix Circuit)
  'turkey': `${LOCAL_CIRCUITS}istanbul_mono.png`,
  'turkije': `${LOCAL_CIRCUITS}istanbul_mono.png`,
  'istanbul': `${LOCAL_CIRCUITS}istanbul_mono.png`,
  'istanbul_park': `${LOCAL_CIRCUITS}istanbul_mono.png`,
  
  // South Africa - Kyalami Grand Prix Circuit
  'south_africa': `${LOCAL_CIRCUITS}kyalami_mono.png`,
  'zuid_afrika': `${LOCAL_CIRCUITS}kyalami_mono.png`,
  'kyalami': `${LOCAL_CIRCUITS}kyalami_mono.png`,
  
  // India - Buddh International Circuit
  'india': `${LOCAL_CIRCUITS}buddh_mono.png`,
  'buddh': `${LOCAL_CIRCUITS}buddh_mono.png`,
  'new_delhi': `${LOCAL_CIRCUITS}buddh_mono.png`,
  
  // Spain - Madrid (Circuito IFEMA Madrid - 2026 onwards)
  'madrid': `${LOCAL_CIRCUITS}madrid_mono.png`,
  'madring': `${LOCAL_CIRCUITS}madrid_mono.png`,
  'ifema': `${LOCAL_CIRCUITS}madrid_mono.png`,
  'ifema_madrid': `${LOCAL_CIRCUITS}madrid_mono.png`,
  
  // Portugal - Estoril (Autódromo Fernanda Pires da Silva)
  'estoril': `${LOCAL_CIRCUITS}estoril_mono.png`,
  'fernanda_pires': `${LOCAL_CIRCUITS}estoril_mono.png`,
  
  // Default fallback
  'default': `${LOCAL_CIRCUITS}default.svg`,
};

// Get circuit layout URL based on race/circuit name
export const getCircuitLayout = (race) => {
  if (!race) return circuitLayouts.default;
  
  // Check for custom circuit layout first (uploaded by admin)
  if (race.custom_circuit_layout) {
    return race.custom_circuit_layout;
  }
  
  // Try multiple fields to find a match
  const searchTerms = [
    race.country,
    race.circuit_name,
    race.name,
    race.location
  ].filter(Boolean);
  
  for (const term of searchTerms) {
    const normalized = term.toLowerCase()
      .replace(/[^a-z0-9]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
    
    // Direct match
    if (circuitLayouts[normalized]) {
      return circuitLayouts[normalized];
    }
    
    // Partial match - check if any key contains the search term
    for (const [key, url] of Object.entries(circuitLayouts)) {
      if (normalized.includes(key) || key.includes(normalized)) {
        return url;
      }
    }
    
    // Check for specific country/location matches (including Dutch names)
    const termLower = term.toLowerCase();
    
    // Argentina
    if (termLower.includes('argentina') || termLower.includes('argentinië') || termLower.includes('buenos')) {
      return circuitLayouts.argentina;
    }
    // Portugal
    if (termLower.includes('portugal') || termLower.includes('portim') || termLower.includes('algarve')) {
      return circuitLayouts.portugal;
    }
    // Malaysia
    if (termLower.includes('malaysia') || termLower.includes('maleisië') || termLower.includes('sepang') || termLower.includes('kuala')) {
      return circuitLayouts.malaysia;
    }
    // Turkey
    if (termLower.includes('turkey') || termLower.includes('turkije') || termLower.includes('istanbul')) {
      return circuitLayouts.turkey;
    }
    // South Africa
    if (termLower.includes('south africa') || termLower.includes('zuid-afrika') || termLower.includes('zuid afrika') || termLower.includes('kyalami')) {
      return circuitLayouts.south_africa;
    }
    // India
    if (termLower.includes('india') || termLower.includes('buddh') || termLower.includes('new delhi') || termLower.includes('noida')) {
      return circuitLayouts.india;
    }
    // Madrid (Spain new circuit from 2026)
    if (termLower.includes('madrid') || termLower.includes('madring') || termLower.includes('ifema')) {
      return circuitLayouts.madrid;
    }
    // Estoril (Portugal)
    if (termLower.includes('estoril') || termLower.includes('fernanda pires')) {
      return circuitLayouts.estoril;
    }
  }
  
  return circuitLayouts.default;
};

// CSS filter to convert black outline to gold (#FDB913) - for F1 media images
export const goldFilter = 'invert(75%) sepia(60%) saturate(500%) hue-rotate(5deg) brightness(95%) contrast(95%)';

// Filter to convert pure black to gold (#FDB913) for monochrome PNGs in dark mode
// Carefully tuned to produce F1-style gold color
export const LOCAL_PNG_GOLD_FILTER = 'invert(72%) sepia(78%) saturate(1000%) hue-rotate(358deg) brightness(100%) contrast(100%)';

// Filter to convert pure black to dark blue (#1a2332) for monochrome PNGs in light mode
// Black already looks good on light backgrounds, just ensure proper visibility
export const LOCAL_PNG_DARK_BLUE_FILTER = 'invert(10%) sepia(50%) saturate(1500%) hue-rotate(180deg) brightness(95%) contrast(90%)';

// Export aliases for backward compatibility
export const FILTER_GOLD = goldFilter;
export const FILTER_DARK_BLUE = 'brightness(0) saturate(100%) invert(10%) sepia(20%) saturate(1000%) hue-rotate(180deg)';

// Legacy alias - now use LOCAL_PNG_GOLD_FILTER for PNGs
export const LOCAL_SVG_GOLD_FILTER = LOCAL_PNG_GOLD_FILTER;

// Alias for getCircuitLayout
export const getCircuitLayoutUrl = getCircuitLayout;

export default circuitLayouts;
